import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class UserStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

